import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconLiveBroadcastStyle0 = cosmosIconCss;

const CosmosIconLiveBroadcast$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLiveBroadcast extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a54e397aabd27a74d3d11211980bd066db1913ac', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7ceabcabfa7580412bc7c4d974bdf029918f701b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '62f6dbe8c198a7edbbc336cddbb419e8a6947081', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.085 4.272a.5.5 0 0 0-.355.148l-.01-.04a9.14 9.14 0 0 0 .09 13.1.5.5 0 0 0 .71 0l.34-.35a.5.5 0 0 0 0-.71 7.66 7.66 0 0 1-.08-10.94.49.49 0 0 0 0-.7l-.34-.36a.5.5 0 0 0-.355-.148Zm11.84 0a.5.5 0 0 1 .355.148v-.04a9.14 9.14 0 0 1-.09 13.1.5.5 0 0 1-.71 0l-.34-.35a.5.5 0 0 1 0-.71 7.66 7.66 0 0 0 .08-10.94.49.49 0 0 1 0-.7l.35-.36a.5.5 0 0 1 .355-.148ZM14.42 7.69l-.34.37a.49.49 0 0 0 0 .67 3.14 3.14 0 0 1 .93 2.2 3.45 3.45 0 0 1-1 2.28.51.51 0 0 0 0 .68l.35.36a.5.5 0 0 0 .69 0 4.59 4.59 0 0 0 .09-6.61.5.5 0 0 0-.72.05ZM9.5 11a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.25 3a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-.5ZM7.58 7.69l.35.37a.49.49 0 0 1 0 .67 3.17 3.17 0 0 0-.93 2.2 3.45 3.45 0 0 0 1 2.28.51.51 0 0 1 0 .68l-.35.36a.5.5 0 0 1-.69 0 4.6 4.6 0 0 1-.1-6.61.5.5 0 0 1 .72.05Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconLiveBroadcastStyle0; }
}, [1, "cosmos-icon-live-broadcast", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-live-broadcast"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-live-broadcast":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLiveBroadcast$1);
            }
            break;
    } });
}

const CosmosIconLiveBroadcast = CosmosIconLiveBroadcast$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLiveBroadcast, defineCustomElement };
